export const DatePickerTypes = {
  week: 'week',
  date: 'date',
};
